const ProductCard = class {
  constructor(element) {
    this.element = element;
    this.swatches = element.querySelectorAll('.product-card__swatch');
    const productId = element.dataset.productId;
    this.primaryImage = document.getElementById(`primary-image-${productId}`);
    this.secondaryImage = document.getElementById(`secondary-image-${productId}`);
    this._attachListeners();
  }
  _attachListeners() {
    this.swatches.forEach(s => s.addEventListener('click', e => {
      this.swatches.forEach(x => x.classList.remove('active'));
      e.currentTarget.classList.add('active');
      this._updateImages(e.currentTarget.dataset.image);
    }));
  }

  _updateImages(imageUrl) {
    if (this.primaryImage) this.primaryImage.src = imageUrl;
    if (this.secondaryImage) this.secondaryImage.src = imageUrl;
  }
  _handleSwatchClick(evt) {
    // Remove hovered class when a swatch is clicked
    this.element.classList.remove('hovered');

    const clickedSwatch = evt.currentTarget;

    // Remove "active" class from all swatches and add it to the clicked one
    this.swatches.forEach(swatch => swatch.classList.remove('active'));
    clickedSwatch.classList.add('active');

    // Update the primary image based on data-image attribute of the clicked swatch
    const newImage = clickedSwatch.getAttribute('data-image');

    if (this.primaryImage && newImage) {
      this.primaryImage.src = newImage;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-card').forEach(card => new ProductCard(card));
});

export default ProductCard;
